module.exports = __webpack_public_path__ + "img/calendar.7500336a.svg";